<script>
import RequestListWrapper from '../components/RequestListWrapper';

export default {
    name: 'Done',
    extends: RequestListWrapper,
    data() {
        return {
            status: 'Исполнено'
        };
    },
    watch: {},
    computed: {},
    methods: {},
    mounted() {}
};
</script>